import { render, staticRenderFns } from "./UploadContractModal.vue?vue&type=template&id=13c36003&scoped=true&"
import script from "./UploadContractModal.vue?vue&type=script&lang=js&"
export * from "./UploadContractModal.vue?vue&type=script&lang=js&"
import style0 from "./UploadContractModal.vue?vue&type=style&index=0&id=13c36003&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c36003",
  null
  
)

export default component.exports